import { PlusIcon } from "@icons";
import { Picker } from "@design-system/Picker/Picker.lib";
import { useSettings } from "@components/settings/SettingsProvider";
import { OrganizationSettingsPages } from "@components/settings/constants";
import { useCanPerformOrganizationAction } from "@hooks/permissions/organization/useCanPerformOrganizationAction";
import { OrganizationAction } from "@common/userOrganizationRoles";

/**
 * Footer of the close-stage pickers: an "Add stage" row that opens the Closes
 * settings page. Returns a `renderFooter` for data-driven roots (composed
 * roots wrap its result in `Picker.Footer`), or `undefined` when the user
 * cannot manage organization settings.
 */
export const useCloseStageSelectFooter = () => {
    const { open: openSettings } = useSettings();
    const canManageSettings = useCanPerformOrganizationAction(
        OrganizationAction.MANAGE_ORGANIZATION_SETTINGS,
    );

    if (!canManageSettings) {
        return undefined;
    }

    return () => (
        <Picker.Item
            leading={<PlusIcon />}
            onSelect={() => openSettings([OrganizationSettingsPages.CLOSES])}
        >
            Add stage
        </Picker.Item>
    );
};
